import { ResolutionsEnum } from '@/main/services/enum/ResolutionsEnum';
import { KOGMediaQuery } from '@/main/services/utilsLayout';
import styled from 'styled-components';
import { css } from 'styled-components';

interface ITextValue {
  cursor: 'default' | 'pointer';
  textUnderline?: boolean;
}

export const Container = styled.div`
  padding: 0 0 2rem;

  > h2 {
    font-weight: bold;
  }
`;
export const ContainerSection = styled.div`
  background-color: #ecf1f6;
  padding: 1rem;
  border-radius: 6px;
  margin: 0 0 2rem 0;
`;
export const ContainerTitle = styled.div`
  display: flex;
  flex-direction: row;
  align-items: baseline;
  gap: 1rem;

  ${({ theme }) =>
    KOGMediaQuery({
      breakpoint: theme.breakpoints.mobile,
      styles: css`
        flex-wrap: wrap;
      `
    })}
`;

export const TextValue = styled.span<ITextValue>`
  display: block;
  text-align: center;
  text-decoration: ${props => (props.textUnderline ? 'underline' : 'default')};
  ${props =>
    props.cursor === 'default' &&
    `
    cursor: default;
    `}
  ${props =>
    props.cursor === 'pointer' &&
    `
    cursor: pointer;
    `}
`;

export const ContainerBoxGrid = styled.div`
  @media (max-width: 750px) {
    table {
      min-width: 750px;
    }
  }
`;

export const FooterButtons = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
  gap: 1rem;

  > button {
    max-width: 200px;
  }
`;

export const AreaFilterGridSpecialAccounts = styled.div`
  margin-left: auto;

  &&& {
    .MuiFormControl-root {
      margin: -14px 0 0 0;
    }
  }

  ${({ theme }) =>
    KOGMediaQuery({
      breakpoint: theme.breakpoints.mobile,
      styles: css`
        width: 100%;
        margin: 0;
      `
    })}
`;

